import { Link, useLocation } from "react-router-dom";

// Post-payment landing. Stripe / PayPal redirect here after a successful
// subscription — the URL you configure in the provider dashboard is:
//     https://<this-app>/plans/success?provider=stripe&session_id={CHECKOUT_SESSION_ID}
//     https://<this-app>/plans/success?provider=paypal&subscription_id={SUBSCRIPTION_ID}
// This page is intentionally static — the actual entitlement provisioning
// (email onboarding, granting feature flags, etc.) happens out-of-band via
// the payment provider webhook + a manual email step until the entitlement
// automation ships in a later iteration.
export default function PlansSuccess() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const provider = (params.get("provider") || "").toLowerCase();
    const sessionId = params.get("session_id") || params.get("subscription_id") || "";

    const providerLabel = provider === "paypal" ? "PayPal" : provider === "stripe" ? "Stripe" : "your payment provider";

    return (
        <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-6 py-16">
            <div
                className="w-full max-w-xl border border-[#2ec5b6] bg-[#0f1f1c] p-8 md:p-10 text-center"
                data-testid="plans-success-card"
            >
                <div
                    className="w-16 h-16 mx-auto mb-6 rounded-full border-2 border-[#2ec5b6] flex items-center justify-center text-[#2ec5b6] text-3xl"
                    aria-hidden
                >
                    ✓
                </div>
                <h1
                    className="text-3xl md:text-4xl font-semibold tracking-tight"
                    data-testid="plans-success-title"
                >
                    Payment received. Thank you.
                </h1>
                <p className="mt-4 text-base text-[#e2e2e2] leading-relaxed" data-testid="plans-success-body">
                    Your subscription with {providerLabel} is confirmed. Watch your inbox in the
                    next few minutes for your login link and onboarding steps. If nothing arrives
                    within 30 minutes, check spam and then reply to your payment receipt so we can help.
                </p>
                {sessionId && (
                    <div
                        className="mt-6 text-[11px] text-[#7a7a7a] font-mono break-all"
                        data-testid="plans-success-reference"
                    >
                        Reference: {sessionId}
                    </div>
                )}
                <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
                    <Link
                        to="/"
                        className="px-6 py-3 border border-[#2a2a2a] text-[#e2e2e2] hover:bg-[#1a1a1a] transition-colors text-sm tracking-wide"
                        data-testid="plans-success-home"
                    >
                        Back to home
                    </Link>
                    <Link
                        to="/login"
                        className="btn-primary text-sm"
                        data-testid="plans-success-login"
                    >
                        Sign in to your account
                    </Link>
                </div>
                <p className="mt-8 text-xs text-[#7a7a7a]">
                    Questions? Reply to your Stripe/PayPal receipt or contact your account manager directly.
                </p>
            </div>
        </div>
    );
}
